import { reviewOptionsSnapshot, type Label } from "@/api";
import { TableRow, type TableRowActionBuilder } from "@carbon6/c6-frontend-design";
import { labelUsageText } from "./labelAxis";

export type LabelTableRowActionBuilder = TableRowActionBuilder<LabelTableRow>;

export class LabelTableRow extends TableRow implements Label {
  readonly uuid: string;
  readonly key: string;
  readonly value: string;
  readonly color: number;
  readonly description: string | null;
  readonly managed: boolean;
  // 이 값이 실제로 어디에 쓰이는지(결함 축만). 계약을 아직 받지 못했으면 null 이라 칸을 비운다.
  // 행이 이 값을 가지는 이유는 c6 컬럼 key 가 행 필드여야 하기 때문이다. 표시 문구는 이 값에서 계산한다.
  readonly usage: string | null;
  readonly created_at: string;
  readonly modified_at: string;

  constructor(label: Label, rowActionsBuilder: LabelTableRowActionBuilder | null = null) {
    super(rowActionsBuilder ? (row) => rowActionsBuilder(row as LabelTableRow) : null);
    this.uuid = label.uuid;
    this.key = label.key;
    this.value = label.value;
    this.color = label.color;
    this.description = label.description;
    this.managed = label.managed;
    this.usage = labelUsageText(label, reviewOptionsSnapshot());
    this.created_at = label.created_at;
    this.modified_at = label.modified_at;
  }

  getRowId(): string {
    return this.uuid;
  }

  // 모든 행을 표시한다. 가시성은 서버 조회가 정한다.
  canShow(): boolean {
    return true;
  }

  // 선택 UI 가 없는 목록이라 선택 대상이 아니다.
  canSelect(): boolean {
    return false;
  }
}

export function createLabelTableRow(
  label: Label,
  rowActionsBuilder: LabelTableRowActionBuilder | null = null,
): LabelTableRow {
  return new LabelTableRow(label, rowActionsBuilder);
}

export function createLabelTableRows(
  labels: readonly Label[],
  rowActionsBuilder: LabelTableRowActionBuilder | null = null,
): LabelTableRow[] {
  return labels.map((label) => createLabelTableRow(label, rowActionsBuilder));
}
